import {
  NotificationEvent,
  NotificationType,
} from '../services/notificationsService';

export type NotificationIconKey =
  | 'message'
  | 'booking'
  | 'bookingAccepted'
  | 'bookingUnavailable'
  | 'learning'
  | 'credentialSubmitted'
  | 'credentialAccepted'
  | 'credentialReview'
  | 'credentialRenewal'
  | 'credentialExpired'
  | 'update';

export const getNotificationLabel = (type: NotificationType): string => {
  switch (type) {
    case 'NEW_MESSAGE':
      return 'Message';
    case 'BOOKING_REQUEST_SENT':
      return 'Booking Request';
    case 'BOOKING_REQUEST_ACCEPTED':
      return 'Booking Accepted';
    case 'BOOKING_CAREGIVER_UNAVAILABLE':
      return 'Caregiver Unavailable';
    case 'LEARNING_MODULE_COMPLETED':
      return 'Learning Complete';
    case 'CREDENTIAL_SUBMITTED':
      return 'Credential Submitted';
    case 'CREDENTIAL_ACCEPTED':
      return 'Credential Approved';
    case 'CREDENTIAL_REJECTED':
      return 'Credential Review';
    case 'CREDENTIAL_RENEWAL_REMINDER':
      return 'Renewal Reminder';
    case 'CREDENTIAL_EXPIRED':
      return 'Renewal Needed';
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
};

export const getNotificationIconKey = (type: NotificationType): NotificationIconKey => {
  switch (type) {
    case 'NEW_MESSAGE':
      return 'message';
    case 'BOOKING_REQUEST_SENT':
      return 'booking';
    case 'BOOKING_REQUEST_ACCEPTED':
      return 'bookingAccepted';
    case 'BOOKING_CAREGIVER_UNAVAILABLE':
      return 'bookingUnavailable';
    case 'LEARNING_MODULE_COMPLETED':
      return 'learning';
    case 'CREDENTIAL_SUBMITTED':
      return 'credentialSubmitted';
    case 'CREDENTIAL_ACCEPTED':
      return 'credentialAccepted';
    case 'CREDENTIAL_REJECTED':
      return 'credentialReview';
    case 'CREDENTIAL_RENEWAL_REMINDER':
      return 'credentialRenewal';
    case 'CREDENTIAL_EXPIRED':
      return 'credentialExpired';
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
};

export const getNotificationRoute = (
  event: NotificationEvent,
  caregiverId: string | null | undefined
): string | null => {
  switch (event.type) {
    case 'NEW_MESSAGE':
      return '/messages';
    case 'BOOKING_REQUEST_SENT':
    case 'BOOKING_REQUEST_ACCEPTED':
    case 'BOOKING_CAREGIVER_UNAVAILABLE':
      return '/appointments';
    case 'LEARNING_MODULE_COMPLETED':
      return '/training';
    case 'CREDENTIAL_SUBMITTED':
    case 'CREDENTIAL_ACCEPTED':
    case 'CREDENTIAL_REJECTED':
    case 'CREDENTIAL_RENEWAL_REMINDER':
    case 'CREDENTIAL_EXPIRED':
      return caregiverId ? `/caretaker/${caregiverId}#credentials-upload` : null;
    default: {
      const _exhaustive: never = event.type;
      return _exhaustive;
    }
  }
};

export const getNotificationBodyCopy = (event: NotificationEvent): string => {
  if (event.type === 'BOOKING_CAREGIVER_UNAVAILABLE') {
    return `${event.body} Keep this caregiver in mind for future engagement when they are next available.`;
  }

  return event.body;
};
